exports.useMediaQuery = require('./use-media-query').useMediaQuery;
